module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA+0lEQVRIS2NkoDFgpLH5DMPIgv8RCg4M/xnnMzAwKjAUTmVgUDOEhF5/DgPDrXMMRItBw5xx5T1w6MCD6H+44gMGBkZ5sLyaEQND4RSI0pvnGBgm5BAvhtsCpf8oEU6hL7D4AM0CCn1B2AIK0+8AWjD9GGVuz7QC68ftA3pa8DXZDO4b7rmnGFjW/oXz/wQzM7hsigfz9/gtRPiaHB+ALAJZAAMgi0AWgADIErItIOQDii2AuRjmA2SXw+SGhg9ISrfkRDJ1LAhT+sDAyMBPkmE4Ff9/yLjyvgJqcQ2pDxbAi2yybfr/kIHxfwLjigcHUCwg2zwCGod+nQwAv+S7GfERKxYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/photoorvideo 3.png
// module id = wRu2
// module chunks = 0